var isSupported={};export{isSupported as __exports};
